import ru.ontando.auth.web.Client

fun main() {
    Client().init()
}